// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconInputsClose = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11">
            <polygon
                fill="currentColor"
                points="545.45 16.65 546 16.1 544.9 15.003 544.35 15.553 540.5 19.403 536.65 15.55 536.1 15 535.003 16.1 535.553 16.65 539.403 20.5 535.55 24.35 535 24.9 536.1 25.997 536.65 25.447 540.5 21.597 544.35 25.45 544.9 26 545.997 24.9 545.447 24.35 541.597 20.5"
                transform="translate(-535 -15)"
            />
        </svg>
    );
};

export default React.memo(IconInputsClose);
